import { Component, OnInit, Input } from '@angular/core';
import * as algoliasearch from 'algoliasearch';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() scoreIdentifier: string = "score";

  public searching = false;
  public client;
  public index;

  public people = [];

  constructor() { }

  ngOnInit() {
    this.client = algoliasearch('K4LI2LCJD9', 'ef7d8ddd5a638080c7ea95b68c6100b8');
    this.index = this.client.initIndex('prod_QUIBBL');
  }

  public doSearch(search) {
    if(search.length == 0) {
      this.people = [];
      return;
    }
    this.index.search(search).then((data) => {
      this.people = [];
      for(let item of data.hits) {
        this.people.push(item);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/search/search.component.ts